module.exports = __webpack_public_path__ + "static/img/motion.343c0f25.svg";